<template>
    <div class="index-item-wrapper">
        <div
            class="index-main-row"
            :class="{ 'has-connection-line': hasSubstitutes, 'is-expanded': isExpanded }"
        >
            <index-row
                v-bind="getBaseProps(index)"
                :show-expand-button="hasSubstitutes"
                :is-expanded="isExpanded"
                :checkbox-name="`selectIndex-${index.material_id}`"
                :selected="index.selected"
                @update:selected="$set(index, 'selected', $event)"
                @toggle-expand="toggleExpand"
            />
        </div>

        <transition-slide>
            <div v-if="isExpanded">
                <div class="d-flex flex-column gap-1-5 pb-2">
                    <div v-if="index.substitute_saps?.length > 0">
                        <div class="d-flex flex-column gap-1-5 mt-2 connection-line">
                            <index-row
                                v-for="(substitute, idx) in index.substitute_saps"
                                :key="`substitute-${idx}-${substitute.sap}`"
                                v-bind="getBaseProps(substitute)"
                                :checkbox-name="`selectIndex-${index.material_id}-sap-${substitute.sap}`"
                                :selected="substitute.selected"
                                @update:selected="$set(index.substitute_saps[idx], 'selected', $event)"
                            />
                        </div>
                    </div>
                    <div v-if="index.substitute_eans?.length > 0" class="d-flex flex-column gap-1-5">
                        <p
                            class="typo-label mb-0 substitute-eans-label"
                        >
                            Produkty zamienne do spełnienia warunku sprzedaży:</p>
                        <index-row
                            v-for="(substitute) in index.substitute_eans"
                            :key="substitute.ean"
                            v-bind="getBaseProps(substitute)"
                            is-typo-small
                            :is-checkbox-visible="false"
                            :selected="substitute.selected"
                        />
                    </div>
                </div>
            </div>
        </transition-slide>
    </div>
</template>

<script>
import TransitionSlide from '@/components/global/ui/TransitionSlide.vue'
import IndexRow from './IndexRow.vue'

export default {
    components: {
        TransitionSlide,
        IndexRow
    },
    props: {
        index: {
            type: Object,
            required: true
        },
        showEan: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isExpanded: false
        }
    },
    computed: {
        hasSubstitutes() {
            return (this.index.substitute_saps?.length > 0) || (this.index.substitute_eans?.length > 0)
        }
    },
    methods: {
        toggleExpand() {
            this.isExpanded = !this.isExpanded
        },
        getBaseProps(item) {
            return {
                name: item.name ?? item.material_name ?? '',
                ean: item.ean ?? item.ean_no ?? '',
                sap: item.sap ?? item.material_id ?? '',
                showEan: this.showEan
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.index-item-wrapper{
    --connection-line-offset: 28px;

    .index-main-row {
        padding: 0.5rem 0;
        min-height: 56px;
        display: flex;
        align-items: center;
        width: 100%;
          // Connection line showing parent-child relationship
        &.has-connection-line {
            position: relative;
            &::after {
                position: absolute;
                content: '';
                width: 1px;
                height: calc(100% - 16px);
                background-color: var(--color-gray-400);
                bottom: 0;
                left: var(--connection-line-offset);
                opacity: 0;
                transition: opacity 0.3s ease-in-out;
            }
            &.is-expanded::after {
                opacity: 1;
            }
        }
    }

    .substitute-eans-label {
        // sum columns width of index-ean and index-sap + padding-left
        padding-left:calc(50px + 1rem);
        @include media-breakpoint-up(lg) {
            padding-left:calc(100px + 1rem);
        }
    }

    .connection-line .index-row {
        position: relative;

        &::before {
            position: absolute;
            content: '';
            display: block;
            width: 20px;
            height: 1px;
            background-color: var(--color-gray-400);
            top: 50%;
            left: var(--connection-line-offset);
        }

        &::after {
            position: absolute;
            content: '';
            display: block;
            width: 1px;
            height: calc(100% + 64px);
            background-color: var(--color-gray-400);
            bottom: -16px;
            left: var(--connection-line-offset);
        }

        &:last-of-type {
            &::after {
                bottom: 50%;
            }
        }
    }
}

</style>
